// extracted by mini-css-extract-plugin
module.exports = {"bigImg":"contact__bigImg__TJLGd","containerText":"contact__containerText__2Jp6K","containerLogos":"contact__containerLogos__3MNOj","contactSpan":"contact__contactSpan__2mJAM"};